export enum AnalyticsCounter {
    Main = 'main',
    CrossSite = 'cross-site',
    Scale = 'scale',
}
